/** 交割合約週期 */
export const FUTURES_PERIOD_OPTIONS = [
  { enumName: '_60s', key: '60s', seconds: 60, label: '60s' },
  { enumName: '_120s', key: '120s', seconds: 120, label: '120s' },
  { enumName: '_5m', key: '5m', seconds: 300, label: '5m' },
  { enumName: '_10m', key: '10m', seconds: 600, label: '10m' },
  { enumName: '_20m', key: '20m', seconds: 1200, label: '20m' },
  { enumName: '_30m', key: '30m', seconds: 1800, label: '30m' },
];

export const FUTURES_AMOUNT_PRESETS = [10, 50, 300, 500, 1000];
export const FUTURES_AMOUNT_RATIOS = [0.2, 0.25, 0.5, 0.75, 1];
